export default __webpack_public_path__ + "static/andreesen-horowitz-f72a4c1b554416313bd3de23183cb4d6.png";